import { render, staticRenderFns } from "./window-gallery.global.vue?vue&type=template&id=b5504e8c&"
import script from "./window-gallery.global.vue?vue&type=script&lang=js&"
export * from "./window-gallery.global.vue?vue&type=script&lang=js&"
import style0 from "./window-gallery.global.vue?vue&type=style&index=0&id=b5504e8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports